import useBootstrapData from '@/hooks/useBootstrapData'
import { useRouter } from 'next/router'
import { initialState } from '../SearchForm/utils'
import type { CAR_FORM_STATE_TYPE } from '../types'

const useCarFormInitialValues = () => {
  const { pathname, query } = useRouter()
  const { SEMSearch, SEMSEARCH } = query
  const isHomepage = pathname === '/'

  const {
    isMobile,
    signInStatus: { signedIn },
    webstats: { clientGUID: cguid },
  } = useBootstrapData()

  const initialValues: CAR_FORM_STATE_TYPE = {
    ...initialState,
  }

  return {
    initialValues,
    isMobile,
    signedIn,
    cguid,
    isHomepage,
    SEMSearch,
    SEMSEARCH,
  }
}

export default useCarFormInitialValues
